import ApiService from "./api.service";
// import { TokenService } from './storage.service';
import { CartData } from "./storage.service";

const OrderService = {
  /**
   * User Register Api call
   */
  sendOrder: async function({
    location,
    receipt,
    number,
    name,
    promo_code,
    grand_total,
    productsjson,
    food_total,
    delivery_charge,
    discount_percent,
    night_charge,
    loc_id,
    order_source,
    order_status,
    sender_name,
    sender_email,
    sender_sm,
    sender_sm_handle,
    sender_note,
    payment_method,
    vat,
    intl_transfer_charge,
    discount_breakdown,
  }) {
    const requestData = {
      method: "post",
      // url: `${process.env.VUE_APP_ROOT_API}/saveorder/`,
      // url: `https://v2.manager.khaanpin.com/apiv2/saveorder/`,
      url: `https://manager.khaanpin.com/apiv2/saveorder/`,

      // headers: { "Api-Key": "GfzglFRA.gSxaMxVDvwixVLDeiGcssYrLA2qISoSN" },
      // headers: {
      //   Authorization: `Token ${localStorage.getItem("access_token")}`,
      // },

      data: {
        location,
        receipt,
        number,
        name,
        promo_code,
        grand_total,
        productsjson,
        food_total,
        delivery_charge,
        discount_percent,
        night_charge,
        loc_id,
        order_source,
        order_status,
        sender_name,
        sender_email,
        sender_sm,
        sender_sm_handle,
        sender_note,
        payment_method,
        vat,
        intl_transfer_charge,
        discount_breakdown,
      },
    };

    try {
      const response = await ApiService.customRequest(requestData);
      CartData.setOrderId(response.data.data);
      // CartData.setOrderId("11111");
      // console.log("ORDER RESPONSE in order.service", response);
      return response;
    } catch (error) {
      // console.log("ORDER ERROR in order.service", error);
      return error;
    }
  },
};

export default OrderService;

export { OrderService };
